export default "__VITE_ASSET__e223d3b4__"